<template>
  <section>
    <div class="d-flex flex-column text-center pt-6">
      <h1 class="text-h1">{{ data.title }}</h1>
      <h4 v-if="data.subtitle" class="text-h3">{{ data.subtitle }}</h4>
    </div>

    <v-container>
      <v-row class="justify-center">
        <v-col
          cols="6"
          sm="4"
          md="4"
          lg="3"
          xl="2"
          v-for="tile in data.tiles"
          :key="tile.src"
        >
          <v-img :src="tile.src" contain :aspect-ratio="4 / 3"></v-img>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>


<script>
export default {
  name: "Clients",
  props: ["value"],
  data() {
    return {};
  },
  computed: {
    data() {
      return this.value;
    },
    isDark() {
      return this.value.dark ? true : false;
    },
  },
};
</script>

<style>
</style>